import React, { Fragment } from 'react';

interface SpinnerProps {
  classes?: string;
  setIsLoading?: (value: boolean) => void;
  isLoading: boolean;
}

const Spinner = (props: SpinnerProps) => {
  if (props.isLoading) {
    return (
      <div className={'spinner-container'}>
        <div className={'spinner'}> </div>
      </div>
    );
  }
  return <Fragment />;
};

Spinner.defaultProps = {
  isLoading: false,
};

export default Spinner;
